import { render, staticRenderFns } from "./ServeItemEdit.vue?vue&type=template&id=055aacb2"
import script from "./ServeItemEdit.vue?vue&type=script&lang=js"
export * from "./ServeItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports